import React from 'react';
import css from './SmallRippleSpinner.module.css';

function SmallRippleSpinner() {
  return <div className={css.spinner} />;
}

export default SmallRippleSpinner;
